import { Injectable } from '@angular/core';
import { environment } from '../../../Environment/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class UserRegisterService {
  basePath:string="";
  constructor(private http:HttpClient) { 
      this.basePath = environment.apiUrl;
    }
  public userRegister(request: any): Observable<any>{
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      return this.http.post(this.basePath + 'UserRegistration/userRegister', request, {
        headers,
        observe: 'response',
        responseType: 'json',
      });
    }
    public getuserRegister(IP:any):Observable<any[]>{
        const url = `${this.basePath}UserRegistration/getUserRegister?IP=${IP}`;
        return this.http.get<any[]>(url).pipe(
              map((response: any) => response) // Extract and return the 'value' array
        );
      }
      public userUpdate(request: any): Observable<any>{
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post(this.basePath + 'UserRegistration/UpdateUserDetails', request, {
          headers,
          observe: 'response',
          responseType: 'json',
        });
      }
}
